import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  createStyles,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import AssignmentIcon from "@material-ui/icons/Assignment";
import EventIcon from "@material-ui/icons/Event";
import GradeIcon from "@material-ui/icons/Grade";
import GroupIcon from "@material-ui/icons/Group";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

import { Pagination } from "@material-ui/lab";
import managerTestApi from "api/managerTest";
import { useAppDispatch, useAppSelector } from "app/hooks";
import EmptyComponent from "components/Empty";
import InputField from "components/FormFields/InputField";
import { RadioGroupField } from "components/FormFields/RadioGroupFiled";
import ManageExamStudentsModal from "components/ManageExamStudentsModal";
import {
  fetchPrizeList,
  selectFilterPrizeList,
} from "features/Admin/pages/ManagerPrize/managerPrizeSlice";
import {
  fetchDataOptions,
  selectListClass,
  selectListDepartment,
} from "features/Auth/options/optionsSlice";
import { ListExam, Question } from "models/managerTest";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { dateTimeToFormatYYYYHHMM } from "utils/dateTimeFormat";
import { deduplicateQuestions } from "utils/examPreview";
import * as yup from "yup";
import {
  SelectFilterListExam,
  SelectListExam,
  fetchListExam,
  setFilterListExam,
} from "../../managerExamListSlice";
import CreateQuestion from "./components/CreateQuestion";
import PickOldExamComponent from "./components/PickOldExam";

export default function AddExam() {
  const useStyles = makeStyles((theme: Theme) => ({
    pageWrapper: {
      maxWidth: 1200,
      margin: "0 auto",
      width: "100%",
      paddingBottom: 40,
      minHeight: "calc(100vh - 120px)",
      display: "flex",
      flexDirection: "column",
    },
    headerBanner: {
      background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
      borderRadius: 24,
      padding: "28px 32px",
      color: "#FFFFFF",
      marginBottom: 24,
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 16,
      [theme.breakpoints?.down("sm") || "@media (max-width:600px)"]: {
        padding: "20px 18px",
        borderRadius: 16,
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: "-40%",
        right: "-10%",
        width: 280,
        height: 280,
        background: "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
        pointerEvents: "none",
      },
    },
    stepperCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: "16px 24px",
      marginBottom: 24,
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 16px rgba(15, 23, 42, 0.04)",
    },
    formCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 20,
      padding: "28px 32px",
      marginBottom: 24,
      border: "1px solid #E2E8F0",
      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
      [theme.breakpoints?.down("sm") || "@media (max-width:600px)"]: {
        padding: "20px 16px",
      },
    },
    sectionHeader: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      marginBottom: 20,
      paddingBottom: 12,
      borderBottom: "1px solid #F1F5F9",
    },
    sectionTitle: {
      fontSize: "1.1rem",
      fontWeight: 700,
      color: "#0F172A",
    },
    sectionIcon: {
      color: "#4F46E5",
      fontSize: 22,
    },
    fieldLabel: {
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "#334155",
      marginBottom: 8,
      display: "block",
    },
    timeHelperBadge: {
      backgroundColor: "#EEF2FF",
      color: "#4F46E5",
      fontSize: "0.75rem",
      fontWeight: 600,
      borderRadius: 6,
      padding: "4px 10px",
      marginTop: 6,
      display: "inline-block",
    },
    btnPrimary: {
      background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
      color: "#FFFFFF",
      borderRadius: 12,
      padding: "10px 24px",
      fontWeight: 700,
      fontSize: "0.9rem",
      textTransform: "none",
      boxShadow: "0 4px 14px rgba(37, 99, 235, 0.3)",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        background: "linear-gradient(135deg, #1D4ED8 0%, #1E40AF 100%)",
        boxShadow: "0 6px 18px rgba(37, 99, 235, 0.4)",
      },
      "&:disabled": {
        background: "#94A3B8",
        color: "#FFFFFF",
        boxShadow: "none",
      },
      [theme.breakpoints.down("sm")]: {
        flex: 1,
        padding: "12px 16px",
        fontSize: "0.85rem",
      },
    },
    btnSecondary: {
      backgroundColor: "#F1F5F9",
      color: "#475569",
      borderRadius: 12,
      padding: "10px 20px",
      fontWeight: 600,
      fontSize: "0.9rem",
      textTransform: "none",
      border: "1px solid #CBD5E1",
      marginRight: 12,
      "&:hover": {
        backgroundColor: "#E2E8F0",
        color: "#0F172A",
      },
      [theme.breakpoints.down("sm")]: {
        flex: 1,
        marginRight: 0,
        padding: "12px 16px",
        fontSize: "0.85rem",
      },
    },
    backButton: {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
      color: "#FFFFFF",
      borderRadius: 12,
      padding: "8px 12px",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.25)",
      },
    },
    stickyFooter: {
      position: "sticky",
      bottom: 16,
      zIndex: 100,
      backgroundColor: "rgba(255, 255, 255, 0.94)",
      backdropFilter: "blur(12px)",
      borderRadius: 16,
      padding: "14px 24px",
      border: "1px solid #E2E8F0",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.12)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "auto",
      [theme.breakpoints.down("sm")]: {
        padding: "12px 14px",
        bottom: 8,
        borderRadius: 14,
        gap: 8,
        width: "100%",
      },
    },
    container: {
      maxHeight: 500,
    },
    checkbox: {
      color: "#CBD5E1",
      borderRadius: 5,
    },
  }));

  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 16px",
        backgroundColor: "#F8FAFC",
        color: "#334155",
        fontSize: "0.8rem",
        fontWeight: 700,
        borderBottom: "2px solid #E2E8F0",
      },
      body: {
        padding: "14px 16px",
        fontSize: "0.875rem",
        borderBottom: "1px solid #F1F5F9",
      },
    })
  )(TableCell);

  const classes = useStyles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();
  const currentStep = Number(searchParams.get("step") || "1");
  const modeParam = searchParams.get("mode") || "create";

  const department = useAppSelector(selectListDepartment);
  const classList = useAppSelector(selectListClass);
  const filter = useAppSelector(selectFilterPrizeList);

  const containerRef = useRef<HTMLDivElement>(null);

  // Parent sticky overflow fix from AGENTS.md
  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, []);

  const [valueForm, setValueForm] = useState<Question | undefined>(() => {
    try {
      const saved = sessionStorage.getItem("gpet_add_exam_form");
      return saved ? JSON.parse(saved) : undefined;
    } catch (e) {
      return undefined;
    }
  });

  useEffect(() => {
    if (valueForm) {
      try {
        sessionStorage.setItem("gpet_add_exam_form", JSON.stringify(valueForm));
      } catch (e) {}
    }
  }, [valueForm]);

  useEffect(() => {
    if (currentStep > 1 && !valueForm) {
      setSearchParams({ step: "1" }, { replace: true });
    }
  }, [currentStep, valueForm, setSearchParams]);

  const [createQuestion, setCreateQuestion] = useState(false);
  const [isPickOldExam, setIsPickOldExam] = useState(false);
  const [isShowMainExam, setIsShowMainExam] = useState(true);
  const [openStudentModal, setOpenStudentModal] = useState(false);

  useEffect(() => {
    dispatch(fetchDataOptions());
    dispatch(fetchPrizeList(filter));
  }, [dispatch, filter]);

  const schema = yup.object().shape({
    startDateTime: yup.string().required(`${t("managerTest.vuilongchonngaykiemtra")}`),
    examTime: yup.string().required(`${t("managerTest.vuilongnhapthoigianthi")}`),
    totalPoint: yup.string().required(`${t("managerTest.vuilongnhapthoigianthi")}`),
    classId: yup.array().min(1, "*Vui lòng chọn lớp học"),
    category: yup.string().required("*Vui lòng chọn hình thức kiểm tra"),
  });

  const isDev = process.env.NODE_ENV === "development";
  const initialValue: any = {
    departmentId: "",
    type: "",
    startDateTime: isDev ? moment().add(1, "days").format("YYYY-MM-DDTHH:mm") : "",
    examTime: isDev ? "60" : "",
    prizeId: "",
    totalPoint: isDev ? "100" : "",
    allDepartment: true,
    category: isDev ? "multipleChoice" : "",
    publishAnswerDateTime: "",
    hiddenAnswerDateTime: "",
    allClass: isDev ? true : false,
    classId: [],
    userId: [],
  };

  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: initialValue,
    resolver: yupResolver(schema),
  });

  const handleFormError = (errors: any) => {
    if (errors.classId) {
      toast.error("Chưa chọn lớp học hoặc học viên dự thi! Vui lòng bấm 'Chọn Lớp & Danh Sách Học Viên'.");
    } else if (errors.startDateTime) {
      toast.error("Vui lòng chọn ngày giờ kiểm tra!");
    } else if (errors.examTime) {
      toast.error("Vui lòng nhập thời gian làm bài!");
    } else if (errors.totalPoint) {
      toast.error("Vui lòng nhập tổng điểm!");
    } else if (errors.category) {
      toast.error("Vui lòng chọn hình thức kiểm tra!");
    } else {
      toast.error("Vui lòng nhập đầy đủ các thông tin bắt buộc!");
    }
  };

  const handleSubmitForm = async (value: any) => {
    const classIdList = value.classId || [];
    const userIdList = value.userId || [];

    if (!classIdList || classIdList.length === 0) {
      toast.error("Chưa chọn lớp học hoặc học viên dự thi! Vui lòng bấm nút 'Chọn Lớp & Danh Sách Học Viên' ở mục 1.");
      return;
    }

    const startIso = value.startDateTime;
    const publishIso = value.publishAnswerDateTime;
    const hiddenIso = value.hiddenAnswerDateTime;

    if (startIso && moment(startIso).isBefore(moment(), "minute")) {
      toast.error(`${t("managerTest.vuilongchongiokiemtralonhonhoacbanggiohientai")}`);
      return;
    }

    const examMinutes = Number(value.examTime) || 0;
    const endMoment = moment(startIso).add(examMinutes, "minutes");

    setValueForm({
      ...value,
      startDate: startIso,
      time: moment(startIso).format("HH:mm"),
      publishAnswerDate: publishIso || null,
      hiddenAnswerDate: hiddenIso || null,
      prizeId: Number(value.prizeId) || "",
      totalPoint: Number(value.totalPoint) || "",
      type: value.category === "multipleChoice" ? "CHOICES" : "TYPING",
      classId: value.allClass ? classList.map((x) => x.id) : classIdList,
      userIdList: userIdList.length > 0 ? userIdList : null,
      departmentId: department.map((x) => x.id),
      endDate: endMoment.format("YYYY-MM-DDTHH:mm"),
    });

    const isPickingOld = listExamOldAdded.length > 0 && isOldExam === "true";
    if (isPickingOld) {
      try {
        const examIds = listExamOldAdded.map((x) => x.id).join(",");
        const batchRes: any = await managerTestApi.getBatchExamDetails(examIds, false);
        if (batchRes && batchRes.exams && batchRes.exams.length > 0) {
          setListOldExamAdded(batchRes.exams);
        }
      } catch (err) {
        console.error(err);
      }
    }
    setIsPickOldExam(isPickingOld);
    setCreateQuestion(!isPickingOld);
    setIsShowMainExam(false);
    setSearchParams({ step: "2", mode: isPickingOld ? "pick-old" : "create" });
  };

  // Table old exam
  const [isOldExam, setIsOldExam] = useState("false");
  const typeExam = watch("category");
  const filterListExam = useAppSelector(SelectFilterListExam);
  const listExam = useAppSelector(SelectListExam);
  const [listExamOldAdded, setListOldExamAdded] = useState<ListExam[]>([]);
  const [listQuestionsAdded, setListQuestionsAdded] = useState([]);
  const [initialRandomCount, setInitialRandomCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (isOldExam === "true") {
      if (typeExam === "multipleChoice") {
        dispatch(fetchListExam({ ...filterListExam, type: "CHOICES" }));
      } else {
        dispatch(fetchListExam({ ...filterListExam, type: "TYPING" }));
      }
    } else {
      dispatch(fetchListExam(filterListExam));
    }
  }, [dispatch, filterListExam, isOldExam, typeExam]);

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterListExam({
        ...filterListExam,
        page: page - 1,
      })
    );
  };

  const handleAddExam = (exam: any) => {
    const cloneListAdded = [...listExamOldAdded];
    const findItem = cloneListAdded?.findIndex((x) => x.id === exam.id);
    if (findItem < 0) {
      cloneListAdded.push({ ...exam });
      setListOldExamAdded(cloneListAdded);
    } else {
      const newListAdded = cloneListAdded.filter((item) => item.id !== exam.id);
      setListOldExamAdded(newListAdded);
    }
  };

  return (
    <div ref={containerRef} className={classes.pageWrapper}>
      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Box display="flex" alignItems="center" style={{ gap: 16 }}>
          <IconButton onClick={() => navigate("/admin/exam-list")} className={classes.backButton}>
            <ArrowBackIosIcon style={{ fontSize: 18, marginLeft: 6 }} />
          </IconButton>
          <Box>
            <Typography variant="h5" style={{ fontWeight: 800, letterSpacing: "-0.02em" }}>
              Tạo Mới Đề Thi
            </Typography>
            <Typography variant="body2" style={{ color: "#94A3B8", marginTop: 4 }}>
              Cấu hình thông tin bài thi, lựa chọn lớp học và soạn danh sách câu hỏi
            </Typography>
          </Box>
        </Box>
        <Chip
          icon={<EventIcon style={{ color: "#38BDF8", fontSize: 18 }} />}
          label={`Tạo ngày ${moment().format("DD/MM/YYYY")}`}
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            color: "#F8FAFC",
            fontWeight: 600,
            borderRadius: 10,
            border: "1px solid rgba(255, 255, 255, 0.15)",
          }}
        />
      </Box>

      {/* Stepper Card */}
      <Paper className={classes.stepperCard} elevation={0}>
        <Stepper activeStep={Math.min(Math.max(currentStep - 1, 0), 2)} alternativeLabel style={{ backgroundColor: "transparent", padding: "8px 0" }}>
          <Step>
            <StepLabel>{`1. ${t("managerTest.step.cauhinhbaithi")}`}</StepLabel>
          </Step>
          <Step>
            <StepLabel>{`2. ${t("managerTest.step.soanchoncauhoi")}`}</StepLabel>
          </Step>
          <Step>
            <StepLabel>{`3. ${t("managerTest.step.xemtruocvanop")}`}</StepLabel>
          </Step>
        </Stepper>
      </Paper>

      {currentStep >= 2 && (modeParam === "pick-old" || isPickOldExam) ? (
        <PickOldExamComponent
          valueForm={valueForm}
          setValueForm={setValueForm}
          setListQuestionsAdded={setListQuestionsAdded}
          listQuestionsAdded={listQuestionsAdded}
          data={listExamOldAdded}
          setCreateQuestion={(val: boolean) => {
            setCreateQuestion(val);
            if (val) setSearchParams({ step: "2", mode: "create" });
          }}
          setIsPickOldExam={(val: boolean) => {
            setIsPickOldExam(val);
            if (val) setSearchParams({ step: "2", mode: "pick-old" });
          }}
          setIsShowMainExam={(val: boolean) => {
            setIsShowMainExam(val);
            if (val) setSearchParams({ step: "1" });
          }}
          setInitialRandomCount={setInitialRandomCount}
        />
      ) : currentStep >= 2 ? (
        <CreateQuestion
          valueForm={valueForm}
          setValueForm={setValueForm}
          setCreateQuestion={(val: boolean) => {
            setCreateQuestion(val);
            if (val) setSearchParams({ step: "2", mode: "create" });
          }}
          listQuestionsAdded={deduplicateQuestions(listQuestionsAdded)}
          setIsPickOldExam={(val: boolean) => {
            setIsPickOldExam(val);
            if (val) setSearchParams({ step: "2", mode: "pick-old" });
          }}
          initialRandomCount={initialRandomCount}
        />
      ) : (
        <form onSubmit={handleSubmit(handleSubmitForm, handleFormError)} style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {/* Card 1: Lớp & Học Viên */}
          <Paper className={classes.formCard} elevation={0}>
            <Box className={classes.sectionHeader}>
              <GroupIcon className={classes.sectionIcon} style={{ color: "#0284C7" }} />
              <Typography className={classes.sectionTitle}>
                1. Danh Sách Lớp & Học Viên Dự Thi
              </Typography>
            </Box>

            <Box
              style={{
                backgroundColor: "#F8FAFC",
                borderRadius: 16,
                border: "1px solid #E2E8F0",
                padding: "20px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 16,
              }}
            >
              <Box display="flex" alignItems="center" style={{ gap: 16 }}>
                <Box
                  style={{
                    backgroundColor: "#E0F2FE",
                    color: "#0284C7",
                    width: 48,
                    height: 48,
                    borderRadius: 12,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <GroupIcon style={{ fontSize: 26 }} />
                </Box>
                <Box>
                  <Typography style={{ fontWeight: 700, fontSize: "1rem", color: "#0F172A" }}>
                    Cấu hình lớp thi và đối tượng tham gia
                  </Typography>
                  <Typography style={{ fontSize: "0.875rem", color: "#64748B", marginTop: 2 }}>
                    Đã chọn: <b style={{ color: "#0284C7" }}>{(watch("classId") || []).length} Lớp học</b> •{" "}
                    <b style={{ color: "#10B981" }}>
                      {(watch("userId") || []).length > 0
                        ? `${(watch("userId") || []).length} Học viên chọn riêng`
                        : "Tất cả học viên trong lớp"}
                    </b>
                  </Typography>
                </Box>
              </Box>

              <Button
                variant="contained"
                onClick={() => setOpenStudentModal(true)}
                startIcon={<GroupIcon />}
                style={{
                  backgroundColor: "#0284C7",
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: "0.875rem",
                  borderRadius: 10,
                  padding: "8px 20px",
                  textTransform: "none",
                  boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
                }}
              >
                Chọn Lớp & Danh Sách Học Viên
              </Button>
            </Box>

            {(!watch("classId") || watch("classId").length === 0) && (
              <Box
                style={{
                  backgroundColor: "#FEF2F2",
                  borderRadius: 12,
                  border: "1px solid #FCA5A5",
                  padding: "12px 16px",
                  marginTop: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <ErrorOutlineIcon style={{ color: "#DC2626", fontSize: 20 }} />
                <Typography style={{ fontSize: "0.875rem", fontWeight: 600, color: "#DC2626" }}>
                  Chưa chọn lớp học hoặc học viên dự thi. Vui lòng bấm nút "Chọn Lớp & Danh Sách Học Viên" ở trên để chọn!
                </Typography>
              </Box>
            )}
          </Paper>

          {/* Card 2: Thời gian & Hình thức thi */}
          <Paper className={classes.formCard} elevation={0}>
            <Box className={classes.sectionHeader}>
              <AssignmentIcon className={classes.sectionIcon} />
              <Typography className={classes.sectionTitle}>
                2. Thời Gian & Hình Thức Thi
              </Typography>
            </Box>

            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <label className={classes.fieldLabel}>
                  {t("managerTest.ngaygiokiemtra")} *
                </label>
                <InputField
                  control={control}
                  type="datetime-local"
                  label=""
                  name="startDateTime"
                  size="small"
                  borderRadius="12px"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.fieldLabel}>
                  {t("managerTest.thoigianlambai")} (Phút) *
                </label>
                <InputField
                  control={control}
                  name="examTime"
                  label={t("managerTest.nhapthoigianthi")}
                  size="small"
                  borderRadius="12px"
                />
                <span className={classes.timeHelperBadge}>
                  Ví dụ: 60 = 1 giờ làm bài
                </span>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.fieldLabel}>
                  {t("managerTest.thoigianhienthidapan")}
                </label>
                <InputField
                  control={control}
                  type="datetime-local"
                  label=""
                  name="publishAnswerDateTime"
                  size="small"
                  borderRadius="12px"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.fieldLabel}>
                  {t("managerTest.thoigianandapan")}
                </label>
                <InputField
                  control={control}
                  type="datetime-local"
                  label=""
                  name="hiddenAnswerDateTime"
                  size="small"
                  borderRadius="12px"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.fieldLabel}>
                  {t("managerTest.hinhthuckiemtra")} *
                </label>
                <RadioGroupField
                  name="category"
                  label=""
                  control={control}
                  options={[
                    { label: `${t("managerTest.tracnghiem")}`, value: "multipleChoice" },
                    { label: `${t("managerTest.tuluan")}`, value: "essay" },
                  ]}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.fieldLabel}>
                  {t("managerTest.tongdiem")} *
                </label>
                <InputField
                  control={control}
                  name="totalPoint"
                  label={t("managerTest.nhaptongdiem")}
                  size="small"
                  borderRadius="12px"
                />
              </Grid>
            </Grid>
          </Paper>

          {/* Card 3: Sử dụng câu hỏi từ đề cũ */}
          <Paper className={classes.formCard} elevation={0}>
            <Box className={classes.sectionHeader}>
              <GradeIcon className={classes.sectionIcon} style={{ color: "#F59E0B" }} />
              <Typography className={classes.sectionTitle}>
                3. Sử Dụng Đề Thi Cũ (Tùy Chọn)
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" style={{ gap: 24, marginBottom: 16 }}>
              <Typography style={{ fontWeight: 600, color: "#334155", fontSize: "0.9rem" }}>
                {t("managerTest.dungdethicu")}?
              </Typography>
              <RadioGroup
                name="oldExam"
                row
                onChange={(event) => setIsOldExam(event.target.value)}
                value={isOldExam}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio color="primary" size="small" />}
                  label={t("managerTest.co")}
                  disabled={typeExam === ""}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio color="primary" size="small" />}
                  label={t("managerTest.khong")}
                  disabled={typeExam === ""}
                />
              </RadioGroup>
            </Box>

            {isOldExam === "true" && (
              <Box mt={2}>
                {listExam?.totalPages > 0 ? (
                  <TableContainer component={Paper} className={classes.container} elevation={0} style={{ border: "1px solid #E2E8F0", borderRadius: 12 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width="80px" align="center">
                            {t("luachon")}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {t("managerTest.tieudebaithi")}
                          </StyledTableCell>
                          <StyledTableCell align="center" width="120px">
                            {t("managerTest.socauhoi")}
                          </StyledTableCell>
                          <StyledTableCell align="center" width="180px">
                            {t("managerTest.thoigian")}
                          </StyledTableCell>
                          <StyledTableCell align="center" width="100px">
                            {t("managerTest.tongdiem")}
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {listExam?.content.map((exam, index) => (
                          <TableRow key={exam.id} hover style={{ backgroundColor: listExamOldAdded.some((x) => x.id === exam.id) ? "#F0FDFA" : undefined }}>
                            <StyledTableCell align="center">
                              <Checkbox
                                color="primary"
                                className={classes.checkbox}
                                checked={listExamOldAdded.some((x) => x.id === exam.id)}
                                onChange={() => handleAddExam(exam)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="left" style={{ fontWeight: 600, color: "#0F172A" }}>
                              {exam?.examTitle}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Chip
                                label={`${exam?.examQuestions?.length || 0} câu`}
                                size="small"
                                style={{ backgroundColor: "#EEF2FF", color: "#4F46E5", fontWeight: 600 }}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center" style={{ color: "#64748B" }}>
                              {dateTimeToFormatYYYYHHMM(exam?.startDate)}
                            </StyledTableCell>
                            <StyledTableCell align="center" style={{ fontWeight: 700, color: "#10B981" }}>
                              {exam?.totalPoint}
                            </StyledTableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <EmptyComponent isBorder={false} />
                )}
                {listExam?.totalPages > 1 && (
                  <Box mt={3} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle2" style={{ fontWeight: 600, color: "#64748B" }}>
                      {t("managerTest.tongdethi")}: <b>{listExam.totalElements}</b>
                    </Typography>
                    <Pagination
                      count={Math.ceil(listExam?.totalElements / listExam?.size)}
                      page={listExam?.number + 1}
                      variant="outlined"
                      color="primary"
                      shape="rounded"
                      onChange={(e, page) => handleChangePage(page)}
                    />
                  </Box>
                )}
              </Box>
            )}
          </Paper>

          {/* Sticky Footer */}
          <Paper className={classes.stickyFooter} elevation={0}>
            <Button
              variant="outlined"
              onClick={() => navigate("/admin/exam-list")}
              className={classes.btnSecondary}
            >
              Hủy Bỏ
            </Button>

            <Button
              type="submit"
              variant="contained"
              className={classes.btnPrimary}
              endIcon={<ArrowForwardIcon />}
              disabled={isOldExam === "true" && listExamOldAdded.length === 0}
            >
              Bắt Đầu
            </Button>
          </Paper>
        </form>
      )}

      <ManageExamStudentsModal
        open={openStudentModal}
        onClose={() => setOpenStudentModal(false)}
        classList={classList}
        initialClassIds={watch("classId") || []}
        initialUserIds={watch("userId") || []}
        onSave={(newClassIds, newUserIds) => {
          setValue("classId", newClassIds);
          setValue("userId", newUserIds);
        }}
      />
    </div>
  );
}
